// 회원가입 화면의 "[선택] 눈누레터 받아보기" 체크를 구글·네이버 가입 버튼에도 적용한다.
//
// 소셜 버튼은 이메일 가입 폼과 별개 요청이라 체크박스 값이 따라가지 않는다. 체크 상태를 버튼 주소에
// ?newsletter=1 로 붙여 두면 OmniAuth 가 시작 요청의 쿼리를 콜백의 omniauth.params 로 넘겨준다
// (Users::OmniauthCallbacksController 가 읽는다).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "oauthLink"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasCheckboxTarget) return

    this.oauthLinkTargets.forEach((link) => {
      const url = new URL(link.getAttribute("href"), window.location.origin)
      if (this.checkboxTarget.checked) {
        url.searchParams.set("newsletter", "1")
      } else {
        url.searchParams.delete("newsletter")
      }
      link.setAttribute("href", url.pathname + url.search)
    })
  }
}
